var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"homeView"}},[_c('div',{staticClass:"page"},[_c('Section1'),_c('Section2'),_c('Section3'),_c('Section4'),_c('Section5'),_c('Section6')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }